import find from 'lodash/find';
import styled from 'styled-components';
import React, { FC, useCallback, useContext } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';

import FormContext from 'src/presentation/contexts/FormContext';
import FieldContainer from './FieldContainer';
import TA from '@ad-scripts/presentation/components/common/textarea';
import getErrorMessage from './getErrorMessage';

type TextareaProps = {
  'data-aid'?: string;
  attr: string;
  autoFocus?: boolean;
  className?: string;
  description?: string | JSX.Element;
  disabled?: boolean;
  label?: string | JSX.Element;
  onChange?: Function;
  maxLength?: number;
  placeholder?: string;
  readOnly?: boolean;
  value?: string;
  maxRows?: number;
};

const Textarea: FC<TextareaProps> = ({
  'data-aid': dataAid = null,
  attr,
  autoFocus,
  className,
  description,
  disabled,
  label,
  onChange,
  placeholder,
  readOnly,
  value,
  maxLength,
  maxRows,
}) => {
  const { errors, workingState, updateState, onBlur } = useContext(FormContext);

  const error = find(errors, error => error.attr === attr);
  const onInputChange = useCallback(
    ev => {
      if (onChange) {
        onChange(ev);
      } else {
        updateState(set({}, attr, ev.target.value));
      }
    },
    [attr, updateState, onChange]
  );

  const workingVal = value ? value : get(workingState, attr);

  return (
    <FieldContainer
      error={error ? getErrorMessage(error, label) : undefined}
      label={label}
      description={description}
      data-aid={dataAid}
      control={
        <StyledTA
          autoFocus={autoFocus}
          className={error ? `${className} invalid` : className}
          data-aid={dataAid}
          disabled={disabled}
          isError={!!error}
          maxLength={maxLength}
          maxRows={maxRows}
          onBlur={onBlur}
          onChange={onInputChange}
          placeholder={placeholder}
          readOnly={readOnly}
          value={workingVal}
        />
      }
    />
  );
};

const StyledTA = styled(TA)`
  ::placeholder {
    color: ${p => p.theme.colors.gray500};
  }
`;

export default Textarea;
